import React from 'react';
import { ReactComponent as AgeIcon } from './icons/age-icon.svg';
import { ReactComponent as GenderIcon } from './icons/gender-icon.svg';
import { ReactComponent as MarriageIcon } from './icons/marriage-icon.svg';
import { ReactComponent as KidsIcon } from './icons/kids-icon.svg';
import { ReactComponent as StateIcon } from './icons/state-icon.svg';
import { ReactComponent as ZipIcon } from './icons/zip-icon.svg';
import { ReactComponent as HomeOwnerIcon } from './icons/home-owner-icon.svg';
import { ReactComponent as IncomeRangeIcon } from './icons/income-range-icon.svg';
import { ReactComponent as NetWorthIcon } from './icons/net-worth-icon.svg';
import { ReactComponent as JobTitleIcon } from './icons/job-title-icon.svg';
import { ReactComponent as SeniorityLevelIcon } from './icons/seniority-level-icon.svg';
import { ReactComponent as CompanyIcon } from 'assets/icons/business-outlined.svg';
import { EnvironmentOutlined } from '@ant-design/icons';
import { VOYAGER_KEYS } from '@mm/state/interfaces/voyagerLeads';
import { DemographicAnalyticsKeyType } from '@mm/state/interfaces/botAnalytics';
import styles from './DemographicBarChart.module.css';

export const DemographicBarChartIcon = ({
  name,
}: {
  name: DemographicAnalyticsKeyType;
}) => {
  switch (name) {
    case VOYAGER_KEYS.ageRange:
      return <AgeIcon />;
    case VOYAGER_KEYS.gender:
      return <GenderIcon />;
    case VOYAGER_KEYS.married:
      return <MarriageIcon />;
    case VOYAGER_KEYS.children:
      return <KidsIcon />;
    case VOYAGER_KEYS.personalCity:
      return <EnvironmentOutlined style={{ fontSize: 24 }} />;
    case VOYAGER_KEYS.personalState:
      return <StateIcon />;
    case VOYAGER_KEYS.personalZip:
      return <ZipIcon />;
    case VOYAGER_KEYS.homeOwner:
      return <HomeOwnerIcon />;
    case VOYAGER_KEYS.incomeRange:
      return <IncomeRangeIcon />;
    case VOYAGER_KEYS.netWorth:
      return <NetWorthIcon />;
    case VOYAGER_KEYS.jobTitle:
      return <JobTitleIcon />;
    case VOYAGER_KEYS.department:
      return <CompanyIcon className={styles.icon} />;
    case VOYAGER_KEYS.seniorityLevel:
      return <SeniorityLevelIcon />;
    default:
      return <></>;
  }
};
